var _style, _circle, _circle2, _circle3, _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCrm(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "Capa_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 100.35 93.73",
    style: {
      enableBackground: "new 0 0 100.35 93.73"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:url(#SVGID_1_);}\n\t.st1{fill:url(#SVGID_2_);}\n\t.st2{fill:url(#SVGID_3_);}\n\t.st3{fill:#A3195B;}\n\t.st4{fill:#0F6285;}\n\t.st5{fill:#E94B3D;}\n\t.st6{fill:url(#SVGID_4_);}\n\t.st7{fill:url(#SVGID_5_);}\n\t.st8{fill:url(#SVGID_6_);}\n\t.st9{fill:url(#SVGID_7_);}\n\t.st10{fill:url(#SVGID_8_);}\n\t.st11{fill:url(#SVGID_9_);}\n\t.st12{fill:url(#SVGID_10_);}\n\t.st13{fill:url(#SVGID_11_);}\n\t.st14{fill:url(#SVGID_12_);}\n\t.st15{fill:url(#SVGID_13_);}\n\t.st16{fill:url(#SVGID_14_);}\n\t.st17{fill:url(#SVGID_15_);}\n\t.st18{fill:url(#SVGID_16_);}\n\t.st19{fill:url(#SVGID_17_);}\n\t.st20{fill:url(#SVGID_18_);}\n\t.st21{fill:url(#SVGID_19_);}\n\t.st22{fill:url(#SVGID_20_);}\n\t.st23{fill:none;stroke:#E94B3D;stroke-width:2.1943;stroke-miterlimit:10;}\n\t.st24{fill:url(#SVGID_21_);}\n\t.st25{fill:url(#SVGID_22_);}\n\t.st26{fill:url(#SVGID_23_);}\n\t.st27{fill:url(#SVGID_24_);}\n\t.st28{fill:url(#SVGID_25_);}\n\t.st29{fill:url(#SVGID_26_);}\n\t.st30{fill:url(#SVGID_27_);}\n\t.st31{fill:url(#SVGID_28_);}\n\t.st32{fill:url(#SVGID_29_);}\n\t.st33{fill:url(#SVGID_30_);}\n\t.st34{fill:url(#SVGID_31_);}\n\t.st35{fill:url(#SVGID_32_);}\n\t.st36{fill:none;stroke:url(#SVGID_33_);stroke-width:1.528;stroke-linecap:round;stroke-miterlimit:10;}\n\t.st37{fill:none;stroke:url(#SVGID_34_);stroke-width:1.528;stroke-linecap:round;stroke-miterlimit:10;}\n\t.st38{fill:none;stroke:url(#SVGID_35_);stroke-width:1.528;stroke-linecap:round;stroke-miterlimit:10;}\n\t.st39{fill:none;stroke:url(#SVGID_36_);stroke-width:1.528;stroke-linecap:round;stroke-miterlimit:10;}\n\t.st40{fill:none;stroke:url(#SVGID_37_);stroke-width:1.528;stroke-linecap:round;stroke-miterlimit:10;}\n\t.st41{fill:none;stroke:url(#SVGID_38_);stroke-width:1.528;stroke-linecap:round;stroke-miterlimit:10;}\n\t.st42{fill:none;stroke:url(#SVGID_39_);stroke-width:1.528;stroke-linecap:round;stroke-miterlimit:10;}\n\t.st43{fill:none;stroke:url(#SVGID_40_);stroke-width:1.528;stroke-linecap:round;stroke-miterlimit:10;}\n\t.st44{fill:none;stroke:url(#SVGID_41_);stroke-width:1.528;stroke-linecap:round;stroke-miterlimit:10;}\n\t.st45{fill:none;stroke:url(#SVGID_42_);stroke-width:1.528;stroke-linecap:round;stroke-miterlimit:10;}\n\t.st46{fill:none;stroke:url(#SVGID_43_);stroke-width:1.528;stroke-linecap:round;stroke-miterlimit:10;}\n\t.st47{fill:url(#SVGID_44_);}\n\t.st48{fill:url(#SVGID_45_);}\n\t.st49{fill:url(#SVGID_46_);}\n\t.st50{fill:none;stroke:url(#SVGID_47_);stroke-width:1.528;stroke-linecap:round;stroke-miterlimit:10;}\n\t.st51{fill:none;stroke:url(#SVGID_48_);stroke-width:1.528;stroke-linecap:round;stroke-miterlimit:10;}\n\t.st52{fill:none;stroke:url(#SVGID_49_);stroke-width:1.528;stroke-linecap:round;stroke-miterlimit:10;}\n\t.st53{fill:url(#SVGID_50_);}\n\t.st54{fill:url(#SVGID_51_);}\n\t.st55{fill:url(#SVGID_52_);}\n\t.st56{fill:url(#SVGID_53_);}\n\t.st57{fill:url(#SVGID_54_);}\n\t.st58{fill:url(#SVGID_55_);}\n\t.st59{fill:url(#SVGID_56_);}\n\t.st60{fill:url(#SVGID_57_);}\n\t.st61{fill:url(#SVGID_58_);}\n\t.st62{fill:none;stroke:url(#SVGID_59_);stroke-width:1.528;stroke-miterlimit:10;}\n\t.st63{fill:#FFFFFF;}\n\t.st64{fill:url(#SVGID_60_);}\n\t.st65{fill:url(#SVGID_61_);}\n\t.st66{fill:url(#SVGID_62_);}\n\t.st67{fill:url(#SVGID_63_);}\n\t.st68{fill:url(#SVGID_64_);}\n\t.st69{fill:url(#SVGID_65_);}\n\t.st70{fill:url(#SVGID_66_);}\n\t.st71{fill:url(#SVGID_67_);}\n\t.st72{fill:url(#SVGID_68_);}\n\t.st73{fill:url(#SVGID_69_);}\n\t.st74{fill:url(#SVGID_70_);}\n\t.st75{fill:url(#SVGID_71_);}\n\t.st76{fill:url(#SVGID_72_);}\n\t.st77{fill:url(#SVGID_73_);}\n\t.st78{fill:none;stroke:url(#SVGID_74_);stroke-width:2.0883;stroke-linecap:round;stroke-miterlimit:10;}\n\t.st79{fill:none;stroke:url(#SVGID_75_);stroke-width:2.0883;stroke-linecap:round;stroke-miterlimit:10;}\n\t.st80{fill:none;stroke:url(#SVGID_76_);stroke-width:2.0883;stroke-linecap:round;stroke-miterlimit:10;}\n\t.st81{fill:none;stroke:url(#SVGID_77_);stroke-width:2.0883;stroke-linecap:round;stroke-miterlimit:10;}\n\t.st82{fill:none;stroke:url(#SVGID_78_);stroke-width:2.0883;stroke-linecap:round;stroke-miterlimit:10;}\n\t.st83{fill:none;stroke:url(#SVGID_79_);stroke-width:2.0883;stroke-linecap:round;stroke-miterlimit:10;}\n\t.st84{fill:none;stroke:url(#SVGID_80_);stroke-width:2.0883;stroke-linecap:round;stroke-miterlimit:10;}\n\t.st85{fill:none;stroke:url(#SVGID_81_);stroke-width:2.0883;stroke-linecap:round;stroke-miterlimit:10;}\n\t.st86{fill:none;stroke:url(#SVGID_82_);stroke-width:2.0883;stroke-linecap:round;stroke-miterlimit:10;}\n\t.st87{fill:none;stroke:url(#SVGID_83_);stroke-width:2.0883;stroke-linecap:round;stroke-miterlimit:10;}\n\t.st88{fill:none;stroke:url(#SVGID_84_);stroke-width:2.0883;stroke-linecap:round;stroke-miterlimit:10;}\n\t.st89{fill:url(#SVGID_85_);}\n\t.st90{fill:url(#SVGID_86_);}\n\t.st91{fill:url(#SVGID_87_);}\n\t.st92{fill:none;stroke:url(#SVGID_88_);stroke-width:2.0883;stroke-linecap:round;stroke-miterlimit:10;}\n\t.st93{fill:none;stroke:url(#SVGID_89_);stroke-width:2.0883;stroke-linecap:round;stroke-miterlimit:10;}\n\t.st94{fill:none;stroke:url(#SVGID_90_);stroke-width:2.0883;stroke-linecap:round;stroke-miterlimit:10;}\n\t.st95{fill:url(#SVGID_91_);}\n\t.st96{fill:url(#SVGID_92_);}\n\t.st97{fill:url(#SVGID_93_);}\n\t.st98{fill:url(#SVGID_94_);}\n\t.st99{fill:url(#SVGID_95_);}\n\t.st100{fill:url(#SVGID_96_);}\n\t.st101{fill:url(#SVGID_97_);}\n\t.st102{fill:url(#SVGID_98_);}\n\t.st103{fill:url(#SVGID_99_);}\n\t.st104{fill:none;stroke:url(#SVGID_100_);stroke-width:2.0883;stroke-miterlimit:10;}\n\t.st105{clip-path:url(#SVGID_102_);}\n\t.st106{fill:url(#SVGID_103_);}\n\t.st107{fill:url(#SVGID_104_);}\n\t.st108{fill:url(#SVGID_105_);}\n\t.st109{fill:url(#SVGID_106_);}\n\t.st110{fill:url(#SVGID_107_);}\n\t.st111{fill:none;stroke:#E94B3D;stroke-width:2.3996;stroke-miterlimit:10;}\n\t.st112{fill:url(#SVGID_108_);}\n\t.st113{fill:url(#SVGID_109_);}\n\t.st114{fill:url(#SVGID_110_);}\n\t.st115{fill:url(#SVGID_111_);}\n\t.st116{fill:url(#SVGID_112_);}\n\t.st117{fill:url(#SVGID_113_);}\n\t.st118{fill:url(#SVGID_114_);}\n\t.st119{fill:url(#SVGID_115_);}\n\t.st120{fill:url(#SVGID_116_);}\n\t.st121{fill:url(#SVGID_117_);}\n\t.st122{fill:url(#SVGID_118_);}\n\t.st123{fill:url(#SVGID_119_);}\n\t.st124{fill:none;stroke:url(#SVGID_120_);stroke-width:2.0883;stroke-linecap:round;stroke-miterlimit:10;}\n\t.st125{fill:none;stroke:url(#SVGID_121_);stroke-width:2.0883;stroke-linecap:round;stroke-miterlimit:10;}\n\t.st126{fill:none;stroke:url(#SVGID_122_);stroke-width:2.0883;stroke-linecap:round;stroke-miterlimit:10;}\n\t.st127{fill:none;stroke:url(#SVGID_123_);stroke-width:2.0883;stroke-linecap:round;stroke-miterlimit:10;}\n\t.st128{fill:none;stroke:url(#SVGID_124_);stroke-width:2.0883;stroke-linecap:round;stroke-miterlimit:10;}\n\t.st129{fill:none;stroke:url(#SVGID_125_);stroke-width:2.0883;stroke-linecap:round;stroke-miterlimit:10;}\n\t.st130{fill:none;stroke:url(#SVGID_126_);stroke-width:2.0883;stroke-linecap:round;stroke-miterlimit:10;}\n\t.st131{fill:none;stroke:url(#SVGID_127_);stroke-width:2.0883;stroke-linecap:round;stroke-miterlimit:10;}\n\t.st132{fill:none;stroke:url(#SVGID_128_);stroke-width:2.0883;stroke-linecap:round;stroke-miterlimit:10;}\n\t.st133{fill:none;stroke:url(#SVGID_129_);stroke-width:2.0883;stroke-linecap:round;stroke-miterlimit:10;}\n\t.st134{fill:none;stroke:url(#SVGID_130_);stroke-width:2.0883;stroke-linecap:round;stroke-miterlimit:10;}\n\t.st135{fill:url(#SVGID_131_);}\n\t.st136{fill:url(#SVGID_132_);}\n\t.st137{fill:url(#SVGID_133_);}\n\t.st138{fill:none;stroke:url(#SVGID_134_);stroke-width:2.0883;stroke-linecap:round;stroke-miterlimit:10;}\n\t.st139{fill:none;stroke:url(#SVGID_135_);stroke-width:2.0883;stroke-linecap:round;stroke-miterlimit:10;}\n\t.st140{fill:none;stroke:url(#SVGID_136_);stroke-width:2.0883;stroke-linecap:round;stroke-miterlimit:10;}\n\t.st141{fill:url(#SVGID_137_);}\n\t.st142{fill:url(#SVGID_138_);}\n\t.st143{fill:url(#SVGID_139_);}\n\t.st144{fill:url(#SVGID_140_);}\n\t.st145{fill:url(#SVGID_141_);}\n\t.st146{fill:url(#SVGID_142_);}\n\t.st147{fill:url(#SVGID_143_);}\n\t.st148{fill:url(#SVGID_144_);}\n\t.st149{fill:url(#SVGID_145_);}\n\t.st150{fill:none;stroke:url(#SVGID_146_);stroke-width:2.0883;stroke-miterlimit:10;}\n")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 4.9946,
    y1: 59.5345,
    x2: 90.3175,
    y2: 59.5345
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#0F6285"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1345,
    style: {
      stopColor: "#256183"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3235,
    style: {
      stopColor: "#445C7F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5448,
    style: {
      stopColor: "#655277"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7886,
    style: {
      stopColor: "#873D68"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#A3195B"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "url(#SVGID_1_)",
      strokeWidth: 2.0883,
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    d: "M89.27,32.6   v55.46c0,2.22-1.81,4.03-4.03,4.03H10.07c-2.22,0-4.03-1.81-4.03-4.03V31.01c0-2.22,1.81-4.03,4.03-4.03h32.22"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: 52.2616,
    y1: 52.0203,
    x2: 83.4932,
    y2: 52.0203
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#0F6285"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1345,
    style: {
      stopColor: "#256183"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3235,
    style: {
      stopColor: "#445C7F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5448,
    style: {
      stopColor: "#655277"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7886,
    style: {
      stopColor: "#873D68"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#A3195B"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "url(#SVGID_2_)",
      strokeWidth: 2.0883,
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    d: "M79.22,56.44   H56.54c-1.78,0-3.23-1.45-3.23-3.23v-2.37c0-1.78,1.45-3.23,3.23-3.23h22.68c1.78,0,3.23,1.45,3.23,3.23v2.37   C82.45,54.98,80.99,56.44,79.22,56.44z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: 52.2616,
    y1: 66.6385,
    x2: 83.4932,
    y2: 66.6385
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#0F6285"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1345,
    style: {
      stopColor: "#256183"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3235,
    style: {
      stopColor: "#445C7F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5448,
    style: {
      stopColor: "#655277"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7886,
    style: {
      stopColor: "#873D68"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#A3195B"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "url(#SVGID_3_)",
      strokeWidth: 2.0883,
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    d: "M79.22,71.06   H56.54c-1.78,0-3.23-1.45-3.23-3.23v-2.37c0-1.78,1.45-3.23,3.23-3.23h22.68c1.78,0,3.23,1.45,3.23,3.23v2.37   C82.45,69.6,80.99,71.06,79.22,71.06z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_4_",
    gradientUnits: "userSpaceOnUse",
    x1: 52.2616,
    y1: 81.2568,
    x2: 83.4932,
    y2: 81.2568
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#0F6285"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1345,
    style: {
      stopColor: "#256183"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3235,
    style: {
      stopColor: "#445C7F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5448,
    style: {
      stopColor: "#655277"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7886,
    style: {
      stopColor: "#873D68"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#A3195B"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "url(#SVGID_4_)",
      strokeWidth: 2.0883,
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    d: "M79.22,85.68   H56.54c-1.78,0-3.23-1.46-3.23-3.23v-2.37c0-1.78,1.45-3.23,3.23-3.23h22.68c1.78,0,3.23,1.46,3.23,3.23v2.37   C82.45,84.22,80.99,85.68,79.22,85.68z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_5_",
    gradientUnits: "userSpaceOnUse",
    x1: 56.289,
    y1: 73.9477,
    x2: 80.2488,
    y2: 73.9477
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#0F6285"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1345,
    style: {
      stopColor: "#256183"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3235,
    style: {
      stopColor: "#445C7F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5448,
    style: {
      stopColor: "#655277"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7886,
    style: {
      stopColor: "#873D68"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#A3195B"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "url(#SVGID_5_)",
      strokeWidth: 2.0883,
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    d: "M77.57,76.84   h-18.6c-0.9,0-1.63-0.73-1.63-1.63v-2.51c0-0.9,0.73-1.63,1.63-1.63h18.6c0.9,0,1.63,0.73,1.63,1.63v2.51   C79.2,76.11,78.47,76.84,77.57,76.84z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_6_",
    gradientUnits: "userSpaceOnUse",
    x1: 56.289,
    y1: 59.3294,
    x2: 80.2488,
    y2: 59.3294
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#0F6285"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1345,
    style: {
      stopColor: "#256183"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3235,
    style: {
      stopColor: "#445C7F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5448,
    style: {
      stopColor: "#655277"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7886,
    style: {
      stopColor: "#873D68"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#A3195B"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "url(#SVGID_6_)",
      strokeWidth: 2.0883,
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    d: "M77.75,62.22   H58.79c-0.8,0-1.46-0.65-1.46-1.46v-2.87c0-0.8,0.65-1.46,1.46-1.46h18.96c0.8,0,1.46,0.65,1.46,1.46v2.87   C79.2,61.57,78.55,62.22,77.75,62.22z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_7_",
    gradientUnits: "userSpaceOnUse",
    x1: 16.1821,
    y1: 79.7838,
    x2: 50.2665,
    y2: 79.7838
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#0F6285"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1345,
    style: {
      stopColor: "#256183"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3235,
    style: {
      stopColor: "#445C7F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5448,
    style: {
      stopColor: "#655277"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7886,
    style: {
      stopColor: "#873D68"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#A3195B"
    }
  })), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "url(#SVGID_7_)",
      strokeWidth: 2.0883,
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    x1: 17.23,
    y1: 79.78,
    x2: 49.22,
    y2: 79.78
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_8_",
    gradientUnits: "userSpaceOnUse",
    x1: 21.552,
    y1: 85.6758,
    x2: 50.2665,
    y2: 85.6758
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#0F6285"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1345,
    style: {
      stopColor: "#256183"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3235,
    style: {
      stopColor: "#445C7F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5448,
    style: {
      stopColor: "#655277"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7886,
    style: {
      stopColor: "#873D68"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#A3195B"
    }
  })), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "url(#SVGID_8_)",
      strokeWidth: 2.0883,
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    x1: 22.6,
    y1: 85.68,
    x2: 49.22,
    y2: 85.68
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_9_",
    gradientUnits: "userSpaceOnUse",
    x1: 9.8052,
    y1: 85.6758,
    x2: 20.6197,
    y2: 85.6758
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#0F6285"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1345,
    style: {
      stopColor: "#256183"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3235,
    style: {
      stopColor: "#445C7F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5448,
    style: {
      stopColor: "#655277"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7886,
    style: {
      stopColor: "#873D68"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#A3195B"
    }
  })), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "url(#SVGID_9_)",
      strokeWidth: 2.0883,
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    x1: 10.85,
    y1: 85.68,
    x2: 19.58,
    y2: 85.68
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_10_",
    gradientUnits: "userSpaceOnUse",
    x1: 9.8052,
    y1: 79.7838,
    x2: 14.8023,
    y2: 79.7838
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#0F6285"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1345,
    style: {
      stopColor: "#256183"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3235,
    style: {
      stopColor: "#445C7F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5448,
    style: {
      stopColor: "#655277"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7886,
    style: {
      stopColor: "#873D68"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#A3195B"
    }
  })), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "url(#SVGID_10_)",
      strokeWidth: 2.0883,
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    x1: 10.85,
    y1: 79.78,
    x2: 13.76,
    y2: 79.78
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_11_",
    gradientUnits: "userSpaceOnUse",
    x1: 13.6929,
    y1: 59.0124,
    x2: 46.4161,
    y2: 59.0124
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#0F6285"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1345,
    style: {
      stopColor: "#256183"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3235,
    style: {
      stopColor: "#445C7F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5448,
    style: {
      stopColor: "#655277"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7886,
    style: {
      stopColor: "#873D68"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#A3195B"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "url(#SVGID_11_)",
      strokeWidth: 2.0883,
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    d: "M30.05,43.69   c-8.46,0-15.32,6.86-15.32,15.32c0,8.46,6.86,15.32,15.32,15.32s15.32-6.86,15.32-15.32C45.37,50.55,38.51,43.69,30.05,43.69z    M29.92,59.14L19.58,48.79L29.92,59.14z M29.74,59.33L19.58,69.49L29.74,59.33L29.74,59.33L29.74,59.33l10.54-10.53L29.74,59.33   h15.35H29.74z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_12_",
    gradientUnits: "userSpaceOnUse",
    x1: 11.8102,
    y1: 31.6317,
    x2: 13.7483,
    y2: 33.5698
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#0F6285"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1345,
    style: {
      stopColor: "#256183"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3235,
    style: {
      stopColor: "#445C7F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5448,
    style: {
      stopColor: "#655277"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7886,
    style: {
      stopColor: "#873D68"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#A3195B"
    }
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st14",
    cx: 12.78,
    cy: 32.6,
    r: 1.37
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_13_",
    gradientUnits: "userSpaceOnUse",
    x1: 17.4878,
    y1: 31.6317,
    x2: 19.4259,
    y2: 33.5698
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#0F6285"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1345,
    style: {
      stopColor: "#256183"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3235,
    style: {
      stopColor: "#445C7F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5448,
    style: {
      stopColor: "#655277"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7886,
    style: {
      stopColor: "#873D68"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#A3195B"
    }
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "st15",
    cx: 18.46,
    cy: 32.6,
    r: 1.37
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_14_",
    gradientUnits: "userSpaceOnUse",
    x1: 23.1654,
    y1: 31.6317,
    x2: 25.1035,
    y2: 33.5698
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#0F6285"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1345,
    style: {
      stopColor: "#256183"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3235,
    style: {
      stopColor: "#445C7F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5448,
    style: {
      stopColor: "#655277"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7886,
    style: {
      stopColor: "#873D68"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#A3195B"
    }
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    className: "st16",
    cx: 24.13,
    cy: 32.6,
    r: 1.37
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_15_",
    gradientUnits: "userSpaceOnUse",
    x1: 64.4838,
    y1: 39.0615,
    x2: 90.3175,
    y2: 39.0615
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#0F6285"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1345,
    style: {
      stopColor: "#256183"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3235,
    style: {
      stopColor: "#445C7F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5448,
    style: {
      stopColor: "#655277"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7886,
    style: {
      stopColor: "#873D68"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#A3195B"
    }
  })), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "url(#SVGID_15_)",
      strokeWidth: 2.0883,
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    x1: 65.53,
    y1: 39.06,
    x2: 89.27,
    y2: 39.06
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_16_",
    gradientUnits: "userSpaceOnUse",
    x1: 5.7777,
    y1: 39.0615,
    x2: 59.1884,
    y2: 39.0615
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#0F6285"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1345,
    style: {
      stopColor: "#256183"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3235,
    style: {
      stopColor: "#445C7F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5448,
    style: {
      stopColor: "#655277"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7886,
    style: {
      stopColor: "#873D68"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#A3195B"
    }
  })), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "url(#SVGID_16_)",
      strokeWidth: 2.0883,
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    x1: 6.82,
    y1: 39.06,
    x2: 58.14,
    y2: 39.06
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_17_",
    gradientUnits: "userSpaceOnUse",
    x1: 41.2419,
    y1: 22.4786,
    x2: 95.3518,
    y2: 22.4786
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#0F6285"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1345,
    style: {
      stopColor: "#256183"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3235,
    style: {
      stopColor: "#445C7F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5448,
    style: {
      stopColor: "#655277"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7886,
    style: {
      stopColor: "#873D68"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#A3195B"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "url(#SVGID_17_)",
      strokeWidth: 2.0883,
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    d: "M90.28,3.19   H46.31c-2.22,0-4.03,1.81-4.03,4.03v21.11c0,2.22,1.81,4.03,4.03,4.03h6.99c0,0,8.11,10.74,10.12,9.29c0,0,2.35-0.22,2.35-9.29   h24.5c2.22,0,4.03-1.81,4.03-4.03V7.21C94.31,5,92.5,3.19,90.28,3.19z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_18_",
    gradientUnits: "userSpaceOnUse",
    x1: 50.789,
    y1: 13.2057,
    x2: 59.6016,
    y2: 22.0183
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#0F6285"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1345,
    style: {
      stopColor: "#256183"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3235,
    style: {
      stopColor: "#445C7F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5448,
    style: {
      stopColor: "#655277"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7886,
    style: {
      stopColor: "#873D68"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#A3195B"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M58.92,12.58c1,0.78,1.66,1.85,1.99,3.19h-2.55c-0.27-0.65-0.68-1.17-1.23-1.55    c-0.56-0.38-1.23-0.57-2.01-0.57c-0.65,0-1.23,0.16-1.74,0.48c-0.52,0.32-0.92,0.78-1.21,1.38s-0.43,1.3-0.43,2.11    c0,0.8,0.14,1.49,0.43,2.09c0.29,0.6,0.69,1.06,1.21,1.38s1.1,0.48,1.74,0.48c0.78,0,1.45-0.19,2.01-0.57    c0.56-0.38,0.97-0.9,1.23-1.55h2.55c-0.32,1.35-0.98,2.41-1.99,3.19c-1,0.78-2.26,1.17-3.78,1.17c-1.16,0-2.19-0.26-3.08-0.79    c-0.89-0.52-1.58-1.26-2.07-2.2c-0.49-0.94-0.73-2.01-0.73-3.21c0-1.21,0.24-2.28,0.73-3.23c0.49-0.94,1.18-1.68,2.06-2.2    c0.89-0.52,1.92-0.79,3.09-0.79C56.65,11.41,57.92,11.8,58.92,12.58z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_19_",
    gradientUnits: "userSpaceOnUse",
    x1: 61.3969,
    y1: 12.861,
    x2: 72.0154,
    y2: 23.4795
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#0F6285"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1345,
    style: {
      stopColor: "#256183"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3235,
    style: {
      stopColor: "#445C7F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5448,
    style: {
      stopColor: "#655277"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7886,
    style: {
      stopColor: "#873D68"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#A3195B"
    }
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st21",
    d: "M69.09,23.72l-2.85-4.75h-1.07v4.75h-2.44V11.53h4.64c1.42,0,2.49,0.35,3.24,1.04s1.11,1.6,1.11,2.73    c0,0.92-0.26,1.69-0.77,2.31c-0.51,0.62-1.25,1.04-2.22,1.24l3.04,4.87H69.09z M65.17,17.29h2c1.39,0,2.09-0.62,2.09-1.85    c0-0.59-0.17-1.04-0.51-1.37c-0.34-0.33-0.87-0.49-1.58-0.49h-2V17.29z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_20_",
    gradientUnits: "userSpaceOnUse",
    x1: 73.6398,
    y1: 11.3923,
    x2: 86.2351,
    y2: 23.9875
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#0F6285"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1345,
    style: {
      stopColor: "#256183"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3235,
    style: {
      stopColor: "#445C7F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5448,
    style: {
      stopColor: "#655277"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7886,
    style: {
      stopColor: "#873D68"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#A3195B"
    }
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M86.51,11.66v12.05h-2.42v-8.41L81,23.72h-2.11l-3.09-8.37v8.37h-2.44V11.66h2.95l3.66,9.06l3.59-9.06H86.51    z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrm);
export default __webpack_public_path__ + "static/media/crm.edcfd5e0c2aa122c44d0ecd2482f4823.svg";
export { ForwardRef as ReactComponent };